<template>
  <div id="app">
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<style lang="scss" src="./assets/sass/style.scss"></style>
<style lang="scss" src="./assets/sass/transitions/fade.scss"></style>

<script>
import pymChild from './embed/index';

export default {
  mounted: () => {
    pymChild.sendHeight();
  },
  updated: () => {
    pymChild.sendHeight();
  },
};
</script>
